// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item_font{font-size:14px}[data-size=\"2\"] .item_font{font-size:14px!important}[data-size=\"3\"] .item_font{font-size:16px!important}[data-size=\"4\"] .item_font{font-size:18px!important}.keyword-highlight{font-weight:800!important}.keyword-highlight,.keyword-highlight-no-bold{color:red!important;font-size:1.05em!important;text-shadow:0 0 1px rgba(255,0,0,.3)!important}", ""]);
// Exports
module.exports = exports;
